var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVideoGameController(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.6889,
    y1: 325.8248,
    x2: 239.6889,
    y2: 487.7658,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M263.667,154.114h-15.364v-13.968c0-2.315-1.876-4.19-4.19-4.19h-35.499 c-10.8,0-19.555-8.755-19.555-19.555v-0.699c0-10.8,8.755-19.555,19.555-19.555h100.478c2.027,0,3.888-1.365,4.274-3.355 c0.519-2.675-1.525-5.025-4.109-5.025h-41.399c-10.8,0-19.555-8.755-19.555-19.555v-2.095c0-4.243,3.439-7.682,7.682-7.682l0,0 c4.243,0,7.682,3.439,7.682,7.682v2.095c0,2.315,1.876,4.19,4.19,4.19h40.832c10.517,0,19.58,8.066,20.097,18.57 c0.554,11.228-8.421,20.54-19.531,20.54H208.612c-2.315,0-4.19,1.876-4.19,4.19v0.699c0,2.315,1.876,4.19,4.19,4.19h35.499 c10.8,0,19.555,8.755,19.555,19.555v13.969H263.667z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.924,
    y1: 351.2148,
    x2: 236.924,
    y2: 382.7548,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M283.649,178.936h-55.327l7.391-26.754c1.294-4.684,5.555-7.927,10.415-7.927h19.714 c4.86,0,9.121,3.244,10.415,7.927L283.649,178.936z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 236.9375,
    y1: 499.0977,
    x2: 236.9375,
    y2: 188.4548,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M508.746,350.73c2.123,7.18,3.254,14.791,3.254,22.67c0,28.801-15.197,54.054-38.006,68.176 c-2.878,1.802-5.894,3.408-9.009,4.819c-0.782,0.363-1.579,0.713-2.388,1.047c-9.47,3.939-19.862,6.118-30.771,6.118 c-22.069,0-42.057-8.911-56.542-23.34c-0.042-0.042-0.097-0.098-0.14-0.14c-0.014-0.014-0.028-0.028-0.042-0.042 c-0.195-0.195-0.391-0.391-0.587-0.587c-0.531-0.531-1.061-1.047-1.593-1.565c-0.53-0.516-1.061-1.034-1.606-1.536 c-0.475-0.461-0.964-0.908-1.439-1.341c-0.307-0.293-0.628-0.587-0.935-0.866c-0.126-0.112-0.266-0.223-0.391-0.335 c-0.042-0.042-0.07-0.084-0.112-0.112c-0.433-0.391-0.866-0.768-1.299-1.159c-0.796-0.699-1.593-1.396-2.402-2.081 c-0.922-0.796-1.872-1.579-2.807-2.333c-0.126-0.112-0.279-0.223-0.419-0.349c-0.028-0.028-0.055-0.042-0.07-0.055 c0,0-0.014-0.014-0.028-0.028c-0.014,0-0.028-0.014-0.055-0.042c-0.279-0.224-0.545-0.433-0.81-0.642 c-0.069-0.055-0.14-0.112-0.209-0.167c-0.573-0.461-1.146-0.908-1.718-1.341c-0.07-0.055-0.14-0.112-0.209-0.154 c-0.154-0.14-0.321-0.266-0.489-0.391c-0.112-0.084-0.223-0.167-0.335-0.252c-0.084-0.07-0.154-0.126-0.238-0.181 c-0.475-0.378-0.964-0.726-1.453-1.089c-0.209-0.167-0.433-0.321-0.656-0.475c-0.378-0.293-0.768-0.573-1.159-0.852 c-0.112-0.084-0.223-0.167-0.335-0.238c-0.531-0.391-1.047-0.754-1.593-1.132c-0.266-0.181-0.516-0.363-0.782-0.531 c-0.055-0.055-0.112-0.098-0.181-0.126c-0.097-0.069-0.181-0.14-0.279-0.209c-0.014,0-0.014,0-0.014,0 c-1.299-0.894-2.612-1.76-3.925-2.612c-0.335-0.224-0.671-0.433-1.02-0.657c-0.279-0.181-0.573-0.363-0.866-0.531 c-0.112-0.084-0.209-0.154-0.321-0.195v-0.014c0,0,0,0-0.014,0c-0.14-0.098-0.293-0.195-0.447-0.293 c-0.321-0.195-0.642-0.391-0.964-0.587c-0.489-0.307-0.978-0.601-1.481-0.88c-0.475-0.307-0.949-0.587-1.439-0.866 c-0.042-0.028-0.084-0.042-0.126-0.069c-0.084-0.042-0.181-0.112-0.293-0.167c-0.167-0.098-0.349-0.195-0.516-0.293 c-1.061-0.614-2.123-1.201-3.199-1.788c-0.014-0.014-0.042-0.014-0.055-0.042c-0.014,0-0.014,0-0.014,0 c-1.089-0.587-2.193-1.173-3.296-1.732c-0.642-0.335-1.285-0.656-1.927-0.978c-0.545-0.279-1.089-0.545-1.648-0.81 c-0.042-0.028-0.084-0.055-0.126-0.069c0,0.014-0.014,0-0.014,0c-0.419-0.209-0.825-0.405-1.243-0.601 c-0.028-0.014-0.055-0.028-0.084-0.028c-0.307-0.154-0.628-0.307-0.949-0.461c-0.685-0.307-1.355-0.614-2.039-0.922 c-0.307-0.154-0.628-0.293-0.935-0.419c-0.266-0.112-0.545-0.238-0.81-0.349c-0.042-0.028-0.069-0.042-0.112-0.042 c-0.014-0.028-0.042-0.028-0.055-0.028c-0.154-0.07-0.321-0.14-0.475-0.224c-0.279-0.112-0.573-0.238-0.866-0.363 c-0.14-0.055-0.279-0.112-0.405-0.167c0,0,0,0-0.014,0c-0.069-0.028-0.14-0.069-0.195-0.098c-0.014,0-0.014,0-0.014,0 c-0.321-0.14-0.642-0.266-0.964-0.391c-0.181-0.084-0.349-0.154-0.531-0.224c-0.238-0.098-0.475-0.195-0.713-0.279 c-0.475-0.195-0.949-0.391-1.425-0.573c-0.293-0.112-0.601-0.238-0.894-0.349c-0.084-0.028-0.167-0.055-0.252-0.098 c-0.866-0.321-1.732-0.656-2.612-0.964c-0.14-0.055-0.293-0.112-0.447-0.167c-1.118-0.405-2.249-0.796-3.38-1.187 c-0.461-0.154-0.922-0.307-1.382-0.461c-0.825-0.266-1.634-0.516-2.459-0.768l-1.634-0.502c-0.852-0.252-1.69-0.489-2.542-0.74 c-0.195-0.055-0.378-0.112-0.559-0.154c-0.811-0.224-1.62-0.447-2.43-0.642c-0.014,0-0.014,0-0.014,0 c-0.028-0.028-0.055-0.028-0.084-0.028c-0.014-0.014-0.028-0.014-0.042-0.014c-0.852-0.224-1.704-0.447-2.57-0.657 c-0.531-0.126-1.075-0.252-1.606-0.377c-0.754-0.181-1.522-0.349-2.276-0.516c-0.726-0.167-1.453-0.321-2.179-0.461 c-0.531-0.112-1.075-0.224-1.606-0.335c-0.922-0.181-1.844-0.349-2.78-0.516c-0.447-0.07-0.894-0.154-1.341-0.238 c-1.146-0.195-2.305-0.378-3.45-0.545c-2.067-0.307-4.148-0.573-6.215-0.796c-0.782-0.098-1.565-0.167-2.333-0.252 c-1.187-0.112-2.374-0.209-3.575-0.293c-0.363-0.042-0.726-0.069-1.089-0.084c-1.104-0.084-2.207-0.154-3.325-0.195 c-1.229-0.069-2.459-0.112-3.674-0.14c-0.252-0.014-0.489-0.014-0.726-0.014c-1.285-0.042-2.57-0.055-3.855-0.055h-0.098 c-0.852,0-1.69,0.014-2.528,0.028h-0.378c-0.391,0-0.768,0.014-1.159,0.028h-0.266c-0.126,0-0.266,0.014-0.391,0.014 c-0.084,0-0.167,0-0.238,0.014c-0.363,0-0.74,0.014-1.103,0.028c-0.433,0.014-0.852,0.028-1.285,0.055 c-0.335,0.014-0.656,0.028-0.978,0.042c-0.167,0-0.335,0.014-0.502,0.028c-0.098,0-0.209,0-0.307,0.028 c-0.181,0-0.363,0-0.545,0.028c-0.112,0-0.238,0-0.349,0.014c-0.587,0.028-1.173,0.069-1.76,0.112c-0.07,0-0.154,0.014-0.224,0.014 c-0.126,0.014-0.252,0.014-0.378,0.028c0,0,0,0-0.014,0c-0.349,0.028-0.685,0.055-1.02,0.084c-0.699,0.055-1.382,0.112-2.081,0.167 c-0.084,0.014-0.167,0.014-0.252,0.028c-0.321,0.028-0.628,0.055-0.935,0.098c-0.642,0.055-1.271,0.126-1.9,0.195 c0,0.014,0,0.014,0,0.014c-0.014-0.014-0.014,0-0.014,0h-0.014c-0.098,0-0.195,0.014-0.293,0.028 c-0.378,0.028-0.754,0.069-1.118,0.126c-1.075,0.126-2.151,0.266-3.213,0.419c-0.112,0.014-0.224,0.028-0.335,0.042 c-0.084,0-0.154,0.014-0.238,0.028c-0.181,0.028-0.378,0.055-0.559,0.084c-0.014,0-0.042,0-0.055,0.014 c-0.447,0.055-0.88,0.112-1.327,0.195c-0.014,0-0.014,0-0.028,0c-0.335,0.055-0.685,0.112-1.02,0.167 c-0.405,0.055-0.811,0.126-1.215,0.195c-1.047,0.167-2.081,0.363-3.129,0.559c-0.545,0.098-1.089,0.209-1.62,0.307 c-0.433,0.084-0.852,0.167-1.271,0.266c-0.069,0-0.126,0.014-0.181,0.042c-0.209,0.028-0.405,0.069-0.614,0.126 c-0.238,0.042-0.475,0.098-0.699,0.14c-0.209,0.042-0.419,0.098-0.614,0.14h-0.014c-0.209,0.042-0.433,0.098-0.628,0.14 c-0.098,0.014-0.181,0.028-0.279,0.055c-0.349,0.084-0.685,0.154-1.02,0.238c-0.252,0.055-0.489,0.112-0.726,0.167 c-0.112,0.028-0.223,0.055-0.335,0.084c-0.405,0.098-0.811,0.195-1.215,0.293c-0.098,0.028-0.195,0.042-0.293,0.07 c-0.502,0.126-1.006,0.252-1.508,0.391c-0.126,0.028-0.266,0.055-0.391,0.098c-0.055,0.014-0.126,0.028-0.181,0.055c0,0,0,0-0.014,0 c-1.439,0.363-2.863,0.768-4.288,1.173c-0.167,0.055-0.335,0.098-0.502,0.154c-0.055,0.014-0.112,0.028-0.167,0.042 c-0.14,0.042-0.279,0.084-0.419,0.14c0,0,0-0.014-0.014,0c-0.154,0.042-0.321,0.084-0.475,0.14c-0.768,0.224-1.522,0.461-2.29,0.713 c-0.405,0.112-0.811,0.252-1.215,0.391c-0.852,0.266-1.69,0.545-2.528,0.838c-0.252,0.084-0.489,0.167-0.713,0.238 c-0.195,0.069-0.405,0.14-0.601,0.209c-0.195,0.069-0.391,0.14-0.587,0.224c-0.545,0.181-1.103,0.378-1.634,0.587 c-0.195,0.069-0.391,0.14-0.573,0.209c-0.167,0.055-0.349,0.126-0.516,0.195c-0.363,0.126-0.726,0.266-1.089,0.405 c-0.238,0.084-0.475,0.181-0.713,0.266c-0.405,0.167-0.796,0.321-1.187,0.489c-0.279,0.098-0.545,0.209-0.811,0.321 c-0.14,0.042-0.279,0.098-0.405,0.154c-0.112,0.042-0.209,0.084-0.307,0.14c-0.223,0.084-0.447,0.167-0.671,0.266 c-0.531,0.209-1.047,0.433-1.55,0.656c-0.181,0.084-0.378,0.154-0.559,0.238c-0.14,0.069-0.293,0.126-0.433,0.195c0,0,0,0-0.014,0 c-0.084,0.028-0.154,0.07-0.238,0.112c-0.181,0.069-0.363,0.154-0.545,0.224c-0.195,0.084-0.378,0.167-0.573,0.266 c-0.321,0.14-0.642,0.279-0.949,0.419c-0.922,0.419-1.829,0.838-2.738,1.271c-0.252,0.112-0.489,0.238-0.726,0.349 c-0.126,0.042-0.252,0.112-0.391,0.181c0,0-0.014,0.014-0.014,0c-0.307,0.14-0.601,0.293-0.908,0.461 c-0.238,0.112-0.461,0.224-0.685,0.335c-0.167,0.069-0.335,0.154-0.489,0.252c-0.055,0.014-0.112,0.042-0.154,0.084 c-0.223,0.084-0.433,0.195-0.656,0.307c-0.378,0.195-0.754,0.391-1.132,0.587c-1.914,0.978-3.799,2.012-5.67,3.073 c-0.656,0.363-1.327,0.754-1.983,1.146c-0.195,0.112-0.405,0.238-0.601,0.349c-0.363,0.209-0.726,0.433-1.089,0.642 c-0.154,0.098-0.321,0.209-0.475,0.307c-0.042,0.014-0.069,0.028-0.098,0.055c-0.181,0.098-0.349,0.209-0.517,0.307 c-0.154,0.084-0.293,0.181-0.433,0.266c-0.223,0.126-0.433,0.266-0.656,0.419c-0.656,0.391-1.299,0.796-1.941,1.215 c-1.55,0.978-3.073,1.998-4.581,3.059c-0.825,0.559-1.648,1.132-2.459,1.718c-0.112,0.084-0.224,0.154-0.335,0.238 c-0.391,0.279-0.782,0.559-1.159,0.852c-0.894,0.642-1.774,1.299-2.654,1.969c-0.014,0.014-0.028,0.014-0.028,0.028 c-1.075,0.825-2.138,1.648-3.199,2.514c-0.181,0.126-0.349,0.279-0.531,0.419c-1.034,0.838-2.067,1.691-3.087,2.57 c-0.811,0.685-1.606,1.369-2.402,2.081c-0.433,0.378-0.866,0.768-1.299,1.159c-0.964,0.866-1.927,1.746-2.878,2.654 c-0.516,0.475-1.034,0.978-1.536,1.467c-0.502,0.489-1.006,0.992-1.508,1.494c-0.042,0.042-0.098,0.098-0.154,0.14 c-0.195,0.195-0.391,0.391-0.573,0.573c-0.126,0.14-0.252,0.266-0.363,0.391c-0.307,0.307-0.614,0.614-0.922,0.935 c0.126-0.154,0.279-0.307,0.419-0.447c-14.429,14.023-34.123,22.656-55.843,22.656C35.897,453.56,0,417.662,0,373.399 c0-8.227,1.243-16.161,3.548-23.633c0.209-0.699,0.433-1.396,0.671-2.081l40.786-126.24c0.266-0.852,0.531-1.705,0.811-2.556 c0.112-0.363,0.238-0.726,0.363-1.089c0.266-0.796,0.545-1.579,0.838-2.374c0.055-0.154,0.112-0.321,0.181-0.489 c0.363-0.978,0.74-1.955,1.146-2.933c0-0.014,0-0.028,0.014-0.042c0.335-0.852,0.699-1.705,1.075-2.556 c0.084-0.209,0.167-0.419,0.266-0.628c0.419-0.964,0.866-1.927,1.313-2.863c0.935-1.998,1.941-3.967,3.017-5.894 c0.531-0.964,1.075-1.914,1.634-2.863c19.555-33.327,55.773-55.703,97.229-55.703c20.589,0,39.877,5.517,56.485,15.155 c7.151,4.148,14.722,7.263,22.53,9.344c15.756,4.219,32.405,4.219,48.161,0c7.808-2.081,15.378-5.196,22.53-9.344 c16.608-9.637,35.897-15.155,56.485-15.155c41.456,0,77.675,22.377,97.229,55.703c0.559,0.949,1.104,1.9,1.634,2.863 c1.075,1.927,2.081,3.897,3.017,5.894c0.447,0.935,0.894,1.9,1.313,2.863c0.14,0.293,0.266,0.601,0.378,0.894 c0.321,0.699,0.614,1.411,0.894,2.123c0.098,0.209,0.181,0.419,0.252,0.642c0.349,0.825,0.671,1.662,0.978,2.5 c0.796,2.137,1.522,4.316,2.193,6.509l5.643,17.488l34.723,107.454c0.042,0.126,0.084,0.238,0.126,0.363 c0.014,0.042,0.028,0.069,0.042,0.112l1.159,3.603C508.689,350.548,508.718,350.632,508.746,350.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.9368,
    y1: 214.765,
    x2: 218.8078,
    y2: 43.8951,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M196.735,391.292c-0.391,0.14-0.782,0.293-1.159,0.447c-0.209,0.069-0.419,0.154-0.628,0.252 c-0.028,0-0.055,0.014-0.084,0.014c-0.405,0.167-0.796,0.321-1.187,0.489c-0.279,0.098-0.545,0.209-0.811,0.321 c-0.14,0.042-0.279,0.098-0.405,0.154c-0.335,0.126-0.656,0.266-0.978,0.405c-0.531,0.209-1.047,0.433-1.55,0.656 c-0.181,0.084-0.363,0.154-0.559,0.238c-0.167,0.055-0.321,0.126-0.475,0.195c-0.754,0.335-1.522,0.671-2.276,1.02 c-0.908,0.405-1.829,0.825-2.738,1.271c-0.042,0.014-0.084,0.042-0.126,0.055c-0.195,0.084-0.405,0.181-0.601,0.293 c-0.126,0.042-0.252,0.112-0.391,0.181c0,0-0.014,0.014-0.014,0c-0.531,0.252-1.061,0.516-1.593,0.796 c-0.167,0.069-0.335,0.154-0.502,0.238c-0.266,0.126-0.531,0.266-0.796,0.405c-0.378,0.195-0.754,0.391-1.132,0.587 c-0.084,0.042-0.181,0.098-0.266,0.14c-1.815,0.935-3.618,1.914-5.406,2.933c-0.656,0.363-1.327,0.754-1.983,1.146 c-0.195,0.112-0.405,0.238-0.601,0.349c-0.726,0.419-1.453,0.866-2.179,1.313c-0.154,0.084-0.293,0.181-0.433,0.266 c-0.069,0.042-0.14,0.084-0.195,0.112c-0.154,0.098-0.307,0.195-0.475,0.293c-0.642,0.405-1.285,0.811-1.927,1.229 c-1.55,0.978-3.073,1.998-4.581,3.059c-0.825,0.559-1.648,1.132-2.459,1.718c-0.112,0.084-0.224,0.154-0.335,0.238 c-0.391,0.279-0.782,0.559-1.159,0.852c-0.894,0.642-1.774,1.299-2.654,1.969c-0.014,0.014-0.028,0.014-0.028,0.028 c-1.075,0.825-2.138,1.648-3.199,2.514c-0.181,0.126-0.349,0.279-0.531,0.419c-1.034,0.838-2.067,1.691-3.087,2.57 c-0.811,0.685-1.606,1.369-2.402,2.081c-0.433,0.378-0.866,0.768-1.299,1.159c-0.964,0.866-1.927,1.746-2.878,2.654 c-0.825,0.768-1.648,1.565-2.459,2.347c-0.055,0.069-0.126,0.14-0.195,0.209l-0.545,0.545c-0.461,0.447-0.908,0.908-1.355,1.369 c-0.028,0.028-0.055,0.055-0.084,0.084c-14.429,14.023-34.123,22.656-55.843,22.656C35.897,453.56,0,417.662,0,373.399 c0-8.227,1.243-16.161,3.548-23.633c0.209-0.699,0.433-1.396,0.671-2.081l40.786-126.24c0.266-0.852,0.531-1.705,0.811-2.556 c0.112-0.363,0.238-0.726,0.363-1.089c0.266-0.796,0.545-1.579,0.838-2.374c0.055-0.154,0.112-0.321,0.181-0.489 c0.363-0.978,0.74-1.955,1.146-2.933c0-0.014,0-0.028,0.014-0.042c0.335-0.852,0.699-1.705,1.075-2.556 c0.084-0.209,0.167-0.419,0.266-0.628c0.419-0.964,0.866-1.927,1.313-2.863c0.949-1.998,1.955-3.967,3.017-5.894 c0.531-0.964,1.075-1.914,1.634-2.863c-5.769,12.781-8.981,26.958-8.981,41.889c0,20.672,6.16,39.892,16.748,55.94 c16.831,25.547,44.878,43.049,77.13,45.521c1.118,0.084,2.235,0.14,3.366,0.195c1.494,0.069,3.003,0.098,4.512,0.098 c1.648,0,3.296-0.042,4.93-0.126c2.053-0.098,4.079-0.252,6.103-0.489c1.676-0.167,3.339-0.391,4.987-0.671 c3.66-0.573,7.249-1.355,10.755-2.305L196.735,391.292z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.9683,
    y1: 209.966,
    x2: 289.9883,
    y2: 284.4561,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M473.994,441.576c-2.878,1.802-5.894,3.408-9.009,4.819c-0.782,0.363-1.579,0.713-2.388,1.047 c-9.47,3.939-19.862,6.118-30.771,6.118c-22.069,0-42.057-8.911-56.542-23.34c-0.042-0.042-0.097-0.098-0.14-0.14 c-0.014-0.014-0.028-0.028-0.042-0.042c-0.195-0.195-0.391-0.391-0.587-0.587c-0.531-0.531-1.061-1.047-1.593-1.565 c-0.53-0.531-1.075-1.034-1.606-1.536c-0.475-0.461-0.964-0.908-1.439-1.341c-0.307-0.293-0.628-0.587-0.935-0.866 c-0.167-0.154-0.335-0.307-0.502-0.447c-0.433-0.391-0.866-0.768-1.299-1.159c-0.796-0.713-1.593-1.396-2.402-2.081 c-0.922-0.796-1.872-1.579-2.807-2.333c-0.126-0.112-0.279-0.223-0.419-0.349c-0.028-0.028-0.055-0.042-0.07-0.055 c0,0-0.014-0.014-0.028-0.028c-0.028-0.014-0.042-0.028-0.055-0.042c-0.279-0.224-0.545-0.433-0.81-0.642 c-0.069-0.055-0.14-0.112-0.209-0.167c-0.573-0.461-1.146-0.908-1.718-1.341c-0.223-0.195-0.461-0.363-0.685-0.545 c0,0,0,0.014-0.014,0c-0.112-0.084-0.223-0.167-0.335-0.252c-0.084-0.07-0.154-0.126-0.238-0.181 c-0.475-0.378-0.964-0.726-1.453-1.089c-0.209-0.167-0.433-0.321-0.656-0.475c-0.378-0.293-0.768-0.573-1.159-0.852 c-0.112-0.084-0.223-0.167-0.335-0.238c-0.531-0.378-1.061-0.754-1.593-1.132c-0.266-0.181-0.516-0.363-0.782-0.531 c-0.055-0.055-0.112-0.098-0.181-0.126c-0.097-0.069-0.195-0.14-0.293-0.209c-1.299-0.894-2.612-1.76-3.925-2.612 c-0.335-0.224-0.671-0.433-1.02-0.657c-0.391-0.252-0.782-0.489-1.173-0.74h-0.014v-0.014c-0.154-0.084-0.307-0.181-0.461-0.279 c-0.321-0.195-0.642-0.391-0.964-0.587c-0.978-0.601-1.941-1.173-2.919-1.746c-0.042-0.028-0.084-0.042-0.126-0.069 c-0.084-0.042-0.181-0.112-0.293-0.167c-0.167-0.098-0.349-0.195-0.516-0.293c-1.089-0.628-2.165-1.229-3.254-1.829 c-0.014,0-0.014,0-0.014,0c-1.089-0.601-2.193-1.173-3.296-1.732c-0.642-0.335-1.285-0.656-1.927-0.978 c-0.545-0.279-1.104-0.545-1.648-0.81c-0.042-0.028-0.084-0.055-0.126-0.069c0,0.014-0.014,0-0.014,0 c-0.419-0.209-0.825-0.405-1.243-0.601c-0.349-0.167-0.699-0.321-1.034-0.489c-0.685-0.307-1.355-0.614-2.039-0.922 c-0.307-0.154-0.628-0.293-0.935-0.419c-0.293-0.14-0.587-0.266-0.88-0.391c-0.195-0.084-0.378-0.167-0.573-0.252 c-0.279-0.112-0.573-0.238-0.866-0.363c-0.14-0.055-0.279-0.112-0.405-0.167c0,0,0,0-0.014,0c-0.069-0.042-0.14-0.069-0.209-0.098 c-0.321-0.14-0.642-0.266-0.964-0.391c-0.181-0.084-0.349-0.154-0.531-0.224c-0.238-0.098-0.475-0.195-0.713-0.279 c-0.475-0.195-0.949-0.391-1.425-0.573c-0.293-0.112-0.587-0.238-0.894-0.349c-0.084-0.028-0.167-0.055-0.252-0.098 c-0.321-0.126-0.657-0.252-0.992-0.378l21.524-54.083c3.506,0.949,7.095,1.732,10.755,2.305c0.098,0.028,0.195,0.042,0.293,0.042 c1.55,0.266,3.115,0.461,4.693,0.628c1.047,0.126,2.095,0.224,3.142,0.307c0.992,0.069,1.983,0.14,2.989,0.181 c0.224,0.014,0.433,0.028,0.656,0.028c1.411,0.069,2.821,0.098,4.246,0.098c1.508,0,3.017-0.028,4.512-0.098 c1.593-0.069,3.171-0.181,4.749-0.321c31.665-2.849,59.153-20.225,75.747-45.395c10.588-16.049,16.748-35.268,16.748-55.94 c0-2.598-0.098-5.182-0.293-7.724c-0.908-12.11-3.925-23.605-8.688-34.165c0.559,0.949,1.104,1.9,1.634,2.863 c1.061,1.927,2.067,3.897,3.017,5.894c0.447,0.935,0.894,1.9,1.313,2.863c0.14,0.293,0.266,0.601,0.378,0.894 c0.321,0.699,0.614,1.411,0.894,2.123c0.098,0.209,0.181,0.419,0.252,0.642c0.349,0.825,0.671,1.662,0.978,2.5 c0.796,2.137,1.522,4.316,2.193,6.509l5.643,17.488l34.723,107.454c0.042,0.126,0.084,0.238,0.126,0.363l1.201,3.715 c0.028,0.084,0.055,0.167,0.083,0.266c2.123,7.18,3.254,14.791,3.254,22.67C512,402.201,496.803,427.454,473.994,441.576z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.3798,
    y1: 239.8871,
    x2: 227.7498,
    y2: 408.5271,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M508.746,350.73c2.123,7.18,3.254,14.791,3.254,22.67c0,28.801-15.197,54.054-38.006,68.176 c-2.878,1.802-5.894,3.408-9.009,4.819c-0.782,0.363-1.579,0.713-2.388,1.047L357.782,342.629l-2.138-2.137l-30.631-30.631 l-0.014-0.014l-12.571-12.571c-0.028-0.028-0.069-0.055-0.098-0.098c-1.006-0.894-1.998-1.802-2.947-2.738 c-0.489-0.475-0.964-0.949-1.425-1.425c-1.411-1.439-2.752-2.933-4.036-4.483c-1.271-1.522-2.473-3.073-3.618-4.679 c-0.028-0.028-0.055-0.069-0.069-0.112c-1.341-1.9-2.598-3.841-3.757-5.853c-0.545-0.908-1.047-1.829-1.55-2.766 c-0.307-0.601-0.614-1.201-0.922-1.815c-0.279-0.545-0.545-1.118-0.81-1.676c-0.181-0.391-0.363-0.782-0.531-1.173 c-0.195-0.433-0.378-0.852-0.559-1.285c-0.209-0.475-0.405-0.964-0.601-1.453c-0.74-1.844-1.411-3.743-2.012-5.657 c-0.223-0.713-0.433-1.425-0.628-2.138c-0.181-0.671-0.363-1.341-0.531-2.012c-0.266-1.089-0.516-2.179-0.74-3.282 c-0.14-0.628-0.252-1.257-0.363-1.9c-0.14-0.726-0.252-1.467-0.363-2.207c-0.084-0.516-0.154-1.034-0.209-1.565 c-0.433-3.254-0.642-6.565-0.642-9.931c0-42.769,34.668-77.437,77.437-77.437c0.922,0,1.829,0.014,2.738,0.055 c0.531,0.014,1.061,0.028,1.579,0.069c0.671,0.028,1.341,0.07,2.012,0.126c1.187,0.098,2.388,0.223,3.562,0.378 c0.545,0.069,1.075,0.14,1.606,0.223c0.224,0.028,0.447,0.055,0.657,0.098c0.391,0.055,0.782,0.126,1.159,0.195 c1.299,0.223,2.585,0.475,3.855,0.768c0.573,0.126,1.159,0.266,1.732,0.419c1.341,0.335,2.668,0.699,3.981,1.104 c0.042,0.014,0.098,0.028,0.154,0.042c1.215,0.391,2.416,0.796,3.589,1.229c0.14,0.042,0.279,0.098,0.405,0.154 c0.559,0.209,1.118,0.419,1.662,0.642c0.642,0.252,1.271,0.502,1.9,0.782c0.587,0.252,1.173,0.516,1.76,0.782 c0.083,0.028,0.167,0.069,0.252,0.112c0.559,0.266,1.132,0.531,1.676,0.81c0.656,0.307,1.299,0.642,1.941,0.992 c0.559,0.293,1.103,0.601,1.648,0.908c0.6,0.335,1.173,0.671,1.76,1.02c0.573,0.335,1.159,0.699,1.718,1.061 c2.276,1.439,4.483,2.989,6.593,4.666c3.687,2.906,7.109,6.16,10.21,9.68l0.209,0.209l43.188,43.202l7.613,7.613l34.723,107.454 c0.042,0.126,0.084,0.238,0.126,0.363l1.201,3.715C508.689,350.548,508.718,350.632,508.746,350.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.6775,
    y1: 405.4848,
    x2: 337.6775,
    y2: 212.5147,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    cx: 363.456,
    cy: 239.037,
    r: 77.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.2248,
    y1: 215.382,
    x2: 7.2517,
    y2: 427.352,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M371.526,352.936l93.458,93.458c-0.782,0.363-1.579,0.713-2.388,1.047 c-9.47,3.939-19.862,6.118-30.771,6.118c-22.069,0-42.057-8.911-56.542-23.34c0.349,0.349,0.699,0.713,1.047,1.075 c-0.391-0.405-0.796-0.81-1.187-1.215c-0.014-0.014-0.028-0.028-0.042-0.042c-0.195-0.195-0.391-0.391-0.587-0.587 c-1.047-1.047-2.123-2.081-3.199-3.101c-0.475-0.447-0.95-0.894-1.439-1.341c-0.447-0.405-0.88-0.81-1.327-1.201 c-0.042-0.042-0.07-0.084-0.112-0.112c-0.433-0.391-0.866-0.768-1.299-1.159c-0.796-0.699-1.593-1.396-2.402-2.081 c-0.922-0.796-1.872-1.579-2.807-2.333c-0.126-0.112-0.279-0.223-0.419-0.349c-0.028-0.028-0.055-0.042-0.07-0.055 c0,0-0.014-0.014-0.028-0.028c-0.014,0-0.028-0.014-0.055-0.042c-0.279-0.224-0.545-0.433-0.81-0.642 c-0.069-0.055-0.14-0.112-0.209-0.167c-0.573-0.461-1.146-0.908-1.718-1.341c-0.223-0.195-0.461-0.363-0.685-0.545 c0,0,0,0.014-0.014,0c-0.112-0.084-0.223-0.167-0.335-0.252c-0.084-0.07-0.154-0.126-0.238-0.181 c-0.475-0.378-0.964-0.726-1.453-1.089c-0.209-0.167-0.433-0.321-0.656-0.475c-0.378-0.293-0.768-0.573-1.159-0.852 c-0.112-0.084-0.223-0.167-0.335-0.238c-0.531-0.378-1.061-0.754-1.593-1.132c-0.266-0.181-0.516-0.363-0.782-0.531 c-0.154-0.126-0.307-0.223-0.461-0.335c-0.014,0-0.014,0-0.014,0c-1.299-0.894-2.612-1.76-3.925-2.612 c-0.628-0.405-1.258-0.811-1.886-1.187c-0.112-0.084-0.209-0.154-0.321-0.195v-0.014c0,0,0,0-0.014,0 c-0.14-0.098-0.293-0.195-0.447-0.293c-0.321-0.195-0.642-0.391-0.964-0.587c-0.489-0.307-0.978-0.601-1.481-0.88 c-0.475-0.307-0.949-0.587-1.439-0.866c-0.042-0.028-0.084-0.042-0.126-0.069c-0.084-0.042-0.181-0.112-0.293-0.167 c-0.167-0.098-0.349-0.195-0.516-0.293c-1.061-0.614-2.123-1.201-3.199-1.788c-0.028-0.014-0.042-0.028-0.069-0.042 c-1.089-0.587-2.193-1.173-3.296-1.732c-0.642-0.335-1.285-0.656-1.927-0.978c-0.545-0.279-1.104-0.545-1.648-0.81 c-0.042-0.028-0.084-0.055-0.126-0.069c0,0.014-0.014,0-0.014,0c-0.419-0.209-0.825-0.405-1.243-0.601 c-0.028-0.014-0.055-0.028-0.084-0.028c-0.992-0.475-1.998-0.935-2.989-1.382c-0.587-0.266-1.159-0.516-1.746-0.768 c-0.042-0.028-0.069-0.042-0.112-0.042c-0.014-0.028-0.042-0.028-0.055-0.028c-0.447-0.209-0.894-0.391-1.341-0.587 c-0.14-0.055-0.279-0.112-0.405-0.167c-0.07-0.028-0.14-0.069-0.209-0.098c-0.014,0-0.014,0-0.014,0 c-0.321-0.14-0.642-0.266-0.964-0.391c-0.181-0.084-0.349-0.154-0.531-0.224c-0.238-0.098-0.475-0.195-0.713-0.279 c-0.475-0.195-0.949-0.391-1.425-0.573c-0.293-0.112-0.587-0.238-0.894-0.349c-0.084-0.028-0.167-0.055-0.252-0.098 c-0.866-0.321-1.732-0.656-2.612-0.964c-0.14-0.055-0.293-0.112-0.447-0.167c-1.118-0.405-2.249-0.796-3.38-1.187 c-0.461-0.154-0.922-0.307-1.382-0.461c-0.825-0.266-1.634-0.516-2.459-0.768l-1.634-0.502c-0.852-0.252-1.69-0.502-2.542-0.74 c-0.195-0.055-0.378-0.112-0.559-0.154c-0.811-0.224-1.62-0.447-2.43-0.642c-0.014,0-0.014,0-0.014,0 c-0.028-0.028-0.055-0.028-0.084-0.028c-0.014-0.014-0.028-0.014-0.042-0.014c-0.852-0.238-1.704-0.447-2.57-0.657 c-0.531-0.14-1.075-0.266-1.606-0.377c-0.754-0.181-1.522-0.363-2.276-0.516c-0.726-0.167-1.453-0.321-2.179-0.461 c-0.531-0.126-1.075-0.224-1.606-0.335c-0.922-0.181-1.858-0.349-2.78-0.516c-0.447-0.07-0.894-0.154-1.341-0.238 c-1.146-0.195-2.305-0.378-3.45-0.545c-2.067-0.307-4.148-0.573-6.215-0.796c-0.782-0.098-1.565-0.167-2.333-0.252 c-1.187-0.112-2.388-0.209-3.575-0.293c-0.363-0.042-0.726-0.069-1.089-0.084c-1.104-0.084-2.221-0.154-3.325-0.195 c-1.215-0.069-2.445-0.112-3.674-0.14c-0.252-0.014-0.489-0.014-0.726-0.014c-1.285-0.042-2.57-0.055-3.855-0.055h-0.098 c-0.838,0-1.69,0-2.528,0.028h-0.601c-0.405,0.014-0.796,0.014-1.201,0.028c-0.126,0-0.266,0.014-0.391,0.014 c-0.084,0-0.167,0-0.238,0.014c-0.796,0.014-1.593,0.042-2.388,0.084c-0.335,0.014-0.656,0.028-0.978,0.042 c-0.279,0.014-0.545,0.028-0.811,0.055c-0.181,0-0.363,0-0.545,0.028c-0.699,0.028-1.41,0.069-2.109,0.126 c-0.07,0-0.154,0.014-0.224,0.014c-0.126,0.014-0.252,0.014-0.378,0.028c0,0,0,0-0.014,0c-0.335,0.028-0.685,0.055-1.02,0.084 c-0.782,0.055-1.565,0.126-2.333,0.195c-0.321,0.028-0.628,0.055-0.935,0.098c-0.642,0.055-1.271,0.126-1.9,0.209 c-0.014-0.014-0.014,0-0.014,0h-0.014c-0.098,0-0.195,0.014-0.293,0.028c-0.378,0.028-0.754,0.084-1.118,0.126 c-1.075,0.126-2.151,0.266-3.213,0.419c-0.112,0.014-0.224,0.028-0.335,0.042c-0.084,0-0.154,0.014-0.238,0.028 c-0.181,0.028-0.378,0.055-0.559,0.084c-0.014,0-0.042,0-0.055,0.014c-0.447,0.055-0.894,0.126-1.327,0.195 c-0.349,0.055-0.699,0.098-1.047,0.167c-0.405,0.055-0.811,0.126-1.215,0.195c-1.047,0.167-2.081,0.363-3.129,0.559 c-0.545,0.098-1.089,0.209-1.62,0.307c-0.433,0.084-0.852,0.167-1.271,0.266c-0.069,0-0.126,0.014-0.181,0.042 c-0.209,0.028-0.405,0.069-0.614,0.126c-0.238,0.042-0.475,0.098-0.699,0.14c-0.209,0.042-0.419,0.084-0.614,0.14h-0.014 c-0.209,0.042-0.433,0.098-0.628,0.14c-0.098,0.014-0.195,0.042-0.279,0.055c-0.349,0.084-0.685,0.154-1.02,0.238 c-0.238,0.055-0.489,0.112-0.726,0.167c-0.112,0.028-0.223,0.055-0.335,0.084c-0.405,0.098-0.811,0.195-1.215,0.293 c-0.098,0.028-0.195,0.042-0.293,0.07c-0.502,0.126-1.006,0.252-1.508,0.391c-0.126,0.028-0.266,0.055-0.391,0.098 c-0.055,0.014-0.126,0.028-0.181,0.042v0.014c0,0,0,0-0.014,0c-1.439,0.363-2.863,0.768-4.288,1.173 c-0.167,0.055-0.335,0.098-0.502,0.154c-0.055,0.014-0.112,0.028-0.167,0.042c-0.14,0.042-0.293,0.084-0.433,0.14 c-0.154,0.042-0.321,0.084-0.475,0.14c-0.768,0.224-1.522,0.461-2.29,0.713c-0.405,0.112-0.811,0.252-1.215,0.391 c-0.838,0.266-1.69,0.545-2.528,0.838c-0.252,0.084-0.489,0.167-0.713,0.238c-0.209,0.069-0.405,0.14-0.601,0.209 c-0.195,0.069-0.391,0.14-0.587,0.224c-0.545,0.181-1.089,0.378-1.634,0.587c-0.195,0.069-0.378,0.14-0.573,0.209 c-0.167,0.055-0.349,0.126-0.516,0.195c-0.195,0.069-0.391,0.14-0.587,0.238c-0.81,0.293-1.606,0.601-2.402,0.922 c-0.279,0.098-0.545,0.209-0.811,0.321l-35.674-35.674l-3.213-3.213l-10.964-10.964l-2.459-2.459l-43.23-43.23 c-0.028-0.028-0.069-0.055-0.098-0.098c-0.992-0.88-1.969-1.774-2.906-2.709h-0.014c-0.014-0.014-0.028-0.014-0.028-0.028 c-0.489-0.475-0.964-0.949-1.425-1.425c-1.411-1.439-2.752-2.933-4.036-4.483c-1.271-1.522-2.473-3.073-3.618-4.679 c-0.028-0.028-0.055-0.069-0.069-0.112c-1.955-2.752-3.715-5.629-5.308-8.618c-0.307-0.601-0.614-1.201-0.922-1.815 c-0.279-0.545-0.545-1.118-0.81-1.676c-0.181-0.391-0.363-0.782-0.531-1.173c-0.195-0.433-0.378-0.852-0.559-1.285 c-0.209-0.475-0.405-0.964-0.601-1.453c-0.74-1.844-1.411-3.743-2.012-5.657c-0.223-0.713-0.433-1.425-0.628-2.138 c-0.181-0.671-0.363-1.341-0.531-2.012c-0.266-1.089-0.516-2.179-0.74-3.282c-0.14-0.628-0.252-1.257-0.363-1.9 c-0.14-0.726-0.252-1.467-0.363-2.207c-0.084-0.516-0.154-1.034-0.209-1.565c-0.433-3.254-0.642-6.565-0.642-9.931 c0-42.769,34.668-77.437,77.437-77.437c0.922,0,1.829,0.014,2.738,0.055c0.531,0.014,1.061,0.028,1.579,0.069 c0.671,0.028,1.341,0.07,2.012,0.126c1.187,0.098,2.388,0.223,3.562,0.378c0.545,0.069,1.075,0.14,1.606,0.223 c0.224,0.028,0.447,0.055,0.656,0.098c0.391,0.055,0.782,0.126,1.159,0.195c1.299,0.223,2.585,0.475,3.855,0.768 c0.573,0.126,1.159,0.266,1.732,0.419c1.341,0.335,2.668,0.699,3.981,1.104c0.042,0.014,0.098,0.028,0.154,0.042 c1.215,0.391,2.416,0.796,3.589,1.229c0.14,0.042,0.279,0.098,0.405,0.154c0.559,0.209,1.118,0.419,1.662,0.642 c0.642,0.252,1.271,0.502,1.9,0.782c0.587,0.252,1.173,0.516,1.76,0.782c0.084,0.028,0.167,0.069,0.252,0.112 c0.559,0.266,1.132,0.531,1.676,0.81c0.656,0.307,1.299,0.642,1.941,0.992c0.559,0.293,1.103,0.601,1.648,0.908 c0.601,0.335,1.173,0.671,1.76,1.02c0.573,0.335,1.159,0.699,1.718,1.061c2.276,1.439,4.483,2.989,6.593,4.666 c3.687,2.906,7.109,6.16,10.21,9.68l0.209,0.209l89.771,89.771l28.145,28.145l4.26,4.26l29.947,29.947l0.461,0.461L371.526,352.936z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.0175,
    y1: 427.0847,
    x2: 136.0175,
    y2: 205.2748,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    cx: 148.352,
    cy: 239.037,
    r: 77.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.1081,
    y1: 259.5053,
    x2: 91.9081,
    y2: 342.7053,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M223.002,257.404l-65.039-65.012c-2.15-2.619-5.413-4.29-9.067-4.29 c-6.477,0-11.727,5.25-11.727,11.727v28.014h-28.014c-6.477,0-11.727,5.25-11.727,11.727c0,3.653,1.671,6.915,4.29,9.067 l64.995,65.043C194.489,307.024,216.341,285.177,223.002,257.404z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.5285,
    y1: 332.5048,
    x2: 136.5285,
    y2: 271.2248,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M188.638,227.843h-28.014v-28.014c0-6.477-5.25-11.727-11.727-11.727 s-11.727,5.25-11.727,11.727v28.014h-28.014c-6.477,0-11.727,5.25-11.727,11.727s5.25,11.727,11.727,11.727h28.014v28.014 c0,6.477,5.25,11.727,11.727,11.727s11.727-5.25,11.727-11.727v-28.014h28.014c6.477,0,11.727-5.25,11.727-11.727 S195.114,227.843,188.638,227.843z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.0754,
    y1: 52.3827,
    x2: 56.6724,
    y2: 364.7827,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M473.994,441.576c-2.878,1.802-5.894,3.408-9.009,4.819 c-0.782,0.363-1.579,0.713-2.388,1.047c-9.47,3.939-19.862,6.118-30.771,6.118c-22.069,0-42.057-8.911-56.542-23.34 c0.349,0.349,0.699,0.713,1.047,1.075c-0.391-0.405-0.796-0.81-1.187-1.215c-0.014-0.014-0.028-0.028-0.042-0.042 c-0.195-0.195-0.391-0.391-0.587-0.587c-1.047-1.047-2.123-2.081-3.199-3.101c-0.475-0.447-0.95-0.894-1.439-1.341 c-0.447-0.405-0.88-0.81-1.327-1.201c-0.042-0.042-0.07-0.084-0.112-0.112c-0.433-0.391-0.866-0.768-1.299-1.159 c-0.796-0.699-1.593-1.396-2.402-2.081c-0.922-0.796-1.872-1.579-2.807-2.333c-0.126-0.112-0.279-0.223-0.419-0.349 c-0.028-0.028-0.055-0.042-0.07-0.055c0,0-0.014-0.014-0.028-0.028c-0.014,0-0.028-0.014-0.055-0.042 c-0.279-0.224-0.545-0.433-0.81-0.642c-0.069-0.055-0.14-0.112-0.209-0.167c-0.573-0.461-1.146-0.908-1.718-1.341 c-0.07-0.055-0.14-0.112-0.209-0.154c-0.154-0.14-0.307-0.252-0.475-0.391c0,0,0,0.014-0.014,0 c-0.112-0.084-0.223-0.167-0.335-0.252c-0.084-0.07-0.154-0.126-0.238-0.181c-0.489-0.363-0.964-0.726-1.453-1.089 c-0.209-0.167-0.433-0.321-0.656-0.475c-0.378-0.293-0.768-0.573-1.159-0.852c-0.112-0.084-0.223-0.167-0.335-0.238 c-0.531-0.378-1.061-0.754-1.593-1.132c-0.266-0.181-0.516-0.363-0.782-0.531c-0.154-0.126-0.307-0.223-0.461-0.335 c-0.014,0-0.014,0-0.014,0c-1.299-0.894-2.612-1.76-3.925-2.612c-0.628-0.405-1.258-0.811-1.886-1.187 c-0.112-0.084-0.209-0.154-0.321-0.195v-0.014c0,0,0,0-0.014,0c-0.14-0.098-0.293-0.195-0.447-0.293 c-0.321-0.195-0.642-0.391-0.964-0.587c-0.489-0.307-0.978-0.601-1.481-0.88c-0.516-0.321-1.034-0.628-1.565-0.935 c-0.084-0.042-0.181-0.112-0.293-0.167c-0.167-0.098-0.349-0.195-0.516-0.293c-1.061-0.614-2.123-1.201-3.199-1.788 c-0.028-0.014-0.042-0.028-0.069-0.042c-1.089-0.587-2.193-1.173-3.296-1.732c-0.642-0.335-1.285-0.656-1.927-0.978 c-0.545-0.279-1.104-0.545-1.648-0.81c-0.042-0.028-0.084-0.055-0.126-0.069c0,0.014-0.014,0-0.014,0 c-0.419-0.209-0.825-0.405-1.243-0.601c-0.028-0.014-0.055-0.028-0.084-0.028c-0.992-0.475-1.998-0.935-2.989-1.382 c-0.587-0.266-1.159-0.516-1.746-0.768c-0.042-0.028-0.069-0.042-0.112-0.042c-0.014-0.028-0.042-0.028-0.055-0.028 c-0.447-0.209-0.894-0.391-1.341-0.587c-0.14-0.055-0.279-0.112-0.405-0.167c-0.07-0.028-0.14-0.069-0.209-0.098 c-0.014,0-0.014,0-0.014,0c-0.321-0.14-0.642-0.266-0.964-0.391c-0.181-0.084-0.349-0.154-0.531-0.224 c-0.238-0.098-0.475-0.195-0.713-0.279c-0.475-0.195-0.949-0.391-1.425-0.573c-0.293-0.112-0.587-0.238-0.894-0.349 c-0.084-0.028-0.167-0.055-0.252-0.098c-0.866-0.321-1.732-0.656-2.612-0.964c-0.14-0.055-0.293-0.112-0.447-0.167 c-1.118-0.405-2.249-0.796-3.38-1.187c-0.461-0.154-0.922-0.307-1.382-0.461c-0.825-0.266-1.634-0.516-2.459-0.768l-1.634-0.502 c-1.034-0.307-2.067-0.601-3.101-0.894c-0.811-0.224-1.62-0.447-2.43-0.642c-0.014,0-0.014,0-0.014,0 c-0.028-0.028-0.055-0.028-0.084-0.028c-0.014-0.014-0.028-0.014-0.042-0.014c-0.852-0.238-1.704-0.447-2.57-0.657 c-0.531-0.14-1.075-0.266-1.606-0.377c-0.754-0.181-1.522-0.363-2.276-0.516c-0.726-0.167-1.453-0.321-2.179-0.461 c-0.531-0.126-1.075-0.224-1.606-0.335c-0.922-0.181-1.858-0.349-2.78-0.516c-0.447-0.07-0.894-0.154-1.341-0.238 c-1.146-0.195-2.305-0.378-3.45-0.545c-2.067-0.307-4.148-0.573-6.215-0.796c-0.782-0.098-1.565-0.167-2.333-0.252 c-1.187-0.112-2.388-0.209-3.575-0.293c-0.363-0.042-0.726-0.069-1.089-0.084c-1.104-0.084-2.221-0.154-3.325-0.195 c-1.215-0.069-2.445-0.112-3.674-0.14c-0.252-0.014-0.489-0.014-0.726-0.014c-1.285-0.042-2.57-0.055-3.855-0.055h-0.098 c-0.852,0-1.69,0.014-2.528,0.028h-0.601c-0.307,0.014-0.628,0.014-0.935,0.028h-0.266c-0.126,0-0.266,0.014-0.391,0.014 c-0.447,0.014-0.894,0.028-1.341,0.042c-0.433,0.014-0.852,0.028-1.285,0.055c-0.335,0.014-0.656,0.028-0.978,0.042 c-0.167,0-0.335,0.014-0.502,0.028c-0.279,0.014-0.573,0.028-0.852,0.055c-0.112,0-0.238,0-0.349,0.014 c-0.587,0.028-1.173,0.069-1.76,0.112c-0.07,0-0.154,0.014-0.224,0.014c-0.126,0-0.252,0.014-0.378,0.028c0,0,0,0-0.014,0 c-0.349,0.028-0.685,0.055-1.02,0.084c-0.699,0.042-1.396,0.112-2.081,0.167c-0.084,0.014-0.167,0.014-0.252,0.028 c-0.321,0.028-0.628,0.055-0.935,0.098c-0.642,0.055-1.271,0.126-1.9,0.195c-0.014,0-0.014,0.014-0.014,0.014h-0.014 c-0.098,0-0.195,0.014-0.293,0.028c-0.378,0.028-0.754,0.084-1.118,0.126c-1.075,0.126-2.151,0.266-3.213,0.419 c-0.112,0-0.224,0.028-0.335,0.042c-0.084,0-0.154,0.014-0.238,0.028c-0.181,0.028-0.378,0.055-0.559,0.084 c-0.014,0-0.042,0-0.055,0.014c-0.447,0.055-0.894,0.126-1.327,0.195c-0.014,0-0.014,0-0.028,0c-0.335,0.055-0.685,0.112-1.02,0.167 c-0.405,0.055-0.811,0.126-1.215,0.195c-1.047,0.167-2.081,0.363-3.129,0.559c-0.545,0.098-1.089,0.209-1.62,0.307 c-0.433,0.084-0.852,0.167-1.271,0.266c-0.069,0-0.126,0.014-0.181,0.042c-0.209,0.028-0.419,0.069-0.614,0.126 c-0.238,0.042-0.475,0.098-0.699,0.14c-0.209,0.042-0.419,0.098-0.614,0.14h-0.014c-0.209,0.042-0.433,0.098-0.628,0.14 c-0.098,0.014-0.195,0.042-0.279,0.055c-0.349,0.084-0.685,0.154-1.02,0.238c-0.252,0.055-0.489,0.112-0.726,0.167 c-0.112,0.028-0.223,0.055-0.335,0.084c-0.405,0.098-0.811,0.195-1.215,0.293c-0.098,0.028-0.195,0.042-0.293,0.07 c-0.502,0.126-1.006,0.252-1.508,0.391c-0.126,0.028-0.266,0.055-0.391,0.098c-0.055,0.014-0.126,0.028-0.181,0.042l-0.014,0.014 c-1.439,0.363-2.863,0.768-4.288,1.173c-0.167,0.055-0.335,0.098-0.502,0.154c-0.195,0.055-0.391,0.112-0.587,0.181 c0,0,0-0.014-0.014,0c-0.154,0.042-0.321,0.084-0.475,0.14c-0.768,0.224-1.522,0.461-2.29,0.713 c-0.405,0.112-0.811,0.252-1.215,0.391c-0.852,0.266-1.69,0.545-2.528,0.838c-0.252,0.084-0.489,0.167-0.713,0.238 c-0.209,0.069-0.405,0.14-0.601,0.209c-0.195,0.069-0.391,0.14-0.587,0.224c-0.545,0.181-1.103,0.378-1.634,0.587 c-0.195,0.069-0.378,0.14-0.573,0.209c-0.167,0.055-0.349,0.126-0.516,0.195c-0.195,0.069-0.391,0.14-0.587,0.238 c-0.378,0.126-0.754,0.266-1.132,0.419c-0.433,0.167-0.852,0.335-1.271,0.502c-0.279,0.098-0.545,0.209-0.811,0.321 c-0.238,0.098-0.475,0.195-0.713,0.293c-0.74,0.293-1.481,0.601-2.221,0.922c-0.181,0.084-0.378,0.154-0.559,0.238 c-0.14,0.069-0.293,0.126-0.433,0.195c0,0,0,0-0.014,0c-0.084,0.028-0.154,0.07-0.238,0.112c-0.378,0.154-0.74,0.321-1.118,0.489 c-0.321,0.14-0.642,0.279-0.949,0.419c-0.922,0.419-1.829,0.838-2.738,1.271c-0.252,0.112-0.489,0.238-0.726,0.349 c-0.126,0.055-0.252,0.126-0.378,0.195c-0.321,0.14-0.628,0.293-0.935,0.447c-0.238,0.112-0.461,0.224-0.685,0.335 c-0.167,0.069-0.335,0.154-0.489,0.252c-0.055,0.014-0.112,0.042-0.154,0.084c-0.601,0.279-1.201,0.587-1.788,0.894 c-1.914,0.978-3.799,2.012-5.67,3.073c-0.656,0.377-1.327,0.754-1.983,1.146c-0.195,0.112-0.405,0.238-0.601,0.349 c-0.517,0.307-1.047,0.628-1.565,0.949c-0.042,0.014-0.069,0.028-0.098,0.055c-0.181,0.098-0.349,0.209-0.517,0.307 c-0.154,0.084-0.293,0.181-0.433,0.266c-0.069,0.042-0.14,0.084-0.195,0.112c-0.154,0.112-0.307,0.195-0.461,0.307 c-0.656,0.391-1.299,0.796-1.941,1.215l-8.31-8.31c-0.028-0.028-0.055-0.055-0.084-0.084c-0.154-0.14-0.307-0.279-0.461-0.433 c-0.167-0.14-0.335-0.293-0.502-0.461c-0.321-0.293-0.642-0.601-0.949-0.908c-0.307-0.307-0.614-0.614-0.922-0.935 c-0.321-0.321-0.628-0.656-0.935-0.992c-0.866-0.964-1.705-1.955-2.5-2.975c-0.811-1.034-1.579-2.109-2.305-3.199 c-0.238-0.378-0.475-0.74-0.713-1.118c-0.699-1.118-1.355-2.262-1.969-3.436c-0.81-1.565-1.55-3.185-2.207-4.833 c-0.014-0.014-0.014-0.014-0.014-0.014c-0.307-0.825-0.614-1.662-0.894-2.5c-0.154-0.419-0.279-0.852-0.419-1.285 c-0.126-0.419-0.252-0.852-0.378-1.285c-0.112-0.433-0.238-0.88-0.335-1.313c-0.112-0.433-0.223-0.88-0.321-1.327c0,0,0,0,0-0.014 c-0.098-0.433-0.181-0.866-0.266-1.313c-0.07-0.293-0.112-0.587-0.167-0.894c-0.055-0.279-0.098-0.559-0.14-0.838 c-0.055-0.321-0.098-0.656-0.14-0.978c-0.069-0.447-0.126-0.908-0.167-1.369c-0.028-0.209-0.055-0.419-0.069-0.642 c-0.028-0.335-0.07-0.685-0.084-1.02c-0.069-0.838-0.112-1.676-0.14-2.514c-0.014-0.461-0.014-0.935-0.014-1.411 c0-6.229,1.118-12.208,3.156-17.725c0.293-0.768,0.587-1.522,0.908-2.262c1.327-3.115,2.947-6.062,4.833-8.814 c9.19-13.395,24.611-22.18,42.084-22.18c0.475,0,0.949,0,1.411,0.014c0.838,0.028,1.69,0.069,2.514,0.14 c0.335,0.028,0.685,0.055,1.02,0.084c0.223,0.014,0.433,0.042,0.642,0.069c0.461,0.042,0.922,0.098,1.369,0.167 c0.321,0.042,0.656,0.084,0.978,0.14c0.279,0.042,0.559,0.084,0.838,0.14c0.307,0.055,0.601,0.098,0.894,0.167 c0.321,0.055,0.628,0.126,0.949,0.181c0.293,0.069,0.601,0.14,0.894,0.209c0.279,0.055,0.545,0.126,0.811,0.195 c0.293,0.069,0.587,0.14,0.866,0.223c0.266,0.055,0.516,0.126,0.768,0.209c0.754,0.209,1.508,0.433,2.249,0.699 c0.266,0.084,0.531,0.167,0.782,0.266c1.844,0.642,3.646,1.396,5.392,2.262c0.391,0.195,0.782,0.391,1.173,0.587 c1.173,0.614,2.319,1.271,3.436,1.984c0.378,0.223,0.754,0.461,1.118,0.713c0.475,0.307,0.949,0.628,1.411,0.964 c0.601,0.433,1.201,0.88,1.788,1.341c0.391,0.279,0.754,0.587,1.132,0.894c0.628,0.516,1.243,1.061,1.844,1.593l0.042,0.042 c0.642,0.6,1.271,1.201,1.886,1.815c0.307,0.321,0.614,0.628,0.908,0.949c0.307,0.321,0.601,0.642,0.894,0.964 c0.042,0.028,0.055,0.055,0.084,0.084l40.31,40.31c0.516,0.461,1.006,0.922,1.508,1.411c0-0.028-0.014-0.042-0.014-0.069 c-0.084-0.545-0.154-1.089-0.223-1.648c-0.098-0.796-0.167-1.593-0.224-2.402c-0.042-0.545-0.069-1.089-0.098-1.634v-0.14 c-0.028-0.642-0.042-1.299-0.042-1.941c0-28.159,22.823-50.982,50.982-50.982c0.88,0,1.76,0.028,2.626,0.069 c0.419,0.014,0.825,0.042,1.243,0.07c0.014,0.014,0.042,0.014,0.055,0.014c0.335,0.028,0.685,0.055,1.02,0.084 c0.224,0.014,0.433,0.042,0.642,0.069c0.461,0.042,0.908,0.098,1.369,0.167c0.266,0.028,0.531,0.069,0.796,0.112 c0.642,0.098,1.285,0.209,1.914,0.335c0.335,0.055,0.685,0.126,1.02,0.209c0.545,0.112,1.089,0.238,1.634,0.378 c0.335,0.084,0.671,0.167,1.006,0.266c0.978,0.252,1.927,0.531,2.878,0.866c0.335,0.112,0.685,0.223,1.02,0.349 c0.502,0.167,1.006,0.363,1.494,0.559c0.754,0.307,1.522,0.628,2.262,0.964c0.07,0.028,0.14,0.055,0.195,0.084 c0.405,0.195,0.796,0.378,1.187,0.573c0.391,0.195,0.796,0.391,1.187,0.587c0.811,0.419,1.593,0.852,2.374,1.327 c0.363,0.224,0.713,0.433,1.061,0.657c0.378,0.223,0.74,0.461,1.118,0.713c0.475,0.307,0.949,0.628,1.411,0.964 c0.601,0.433,1.201,0.88,1.788,1.341c0.391,0.279,0.754,0.587,1.132,0.894c0.628,0.531,1.243,1.061,1.843,1.593 c0.014,0.014,0.028,0.028,0.042,0.042c0.642,0.601,1.271,1.201,1.886,1.815c0.307,0.321,0.614,0.628,0.908,0.949 c0.307,0.321,0.601,0.642,0.894,0.964c0.042,0.028,0.055,0.055,0.083,0.084L473.994,441.576z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.8475,
    y1: 223.3548,
    x2: 175.8475,
    y2: 141.1648,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    cx: 190.837,
    cy: 360.691,
    r: 50.982
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.8475,
    y1: 162.4948,
    x2: 175.8475,
    y2: 227.3148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    cx: 190.837,
    cy: 360.691,
    r: 37.483
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.2104,
    y1: 151.1876,
    x2: 159.6004,
    y2: 200.7876,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    d: "M241.725,363.753l-26.295-26.295c-6.167-6.526-14.898-10.605-24.587-10.605 c-18.686,0-33.834,15.148-33.834,33.834c0,9.689,4.079,18.419,10.606,24.588l26.294,26.294 C219.621,410.042,240.198,389.466,241.725,363.753z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.8475,
    y1: 207.9247,
    x2: 175.8475,
    y2: 149.4148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    cx: 190.837,
    cy: 360.691,
    r: 33.834
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.9975,
    y1: 223.3548,
    x2: 297.9975,
    y2: 141.1648,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    cx: 321.131,
    cy: 360.691,
    r: 50.982
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.9975,
    y1: 162.4948,
    x2: 297.9975,
    y2: 227.3148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#97AAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8EFEE"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    cx: 321.131,
    cy: 360.691,
    r: 37.483
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.349,
    y1: 151.1862,
    x2: 281.749,
    y2: 200.7863,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M372.012,363.753l-26.296-26.295c-6.167-6.526-14.898-10.605-24.587-10.605 c-18.686,0-33.834,15.148-33.834,33.834c0,9.689,4.079,18.419,10.606,24.588l26.294,26.294 C349.908,410.042,370.485,389.466,372.012,363.753z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 297.9975,
    y1: 207.9247,
    x2: 297.9975,
    y2: 149.4148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    cx: 321.131,
    cy: 360.691,
    r: 33.834
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.7945,
    y1: 342.8647,
    x2: 316.7945,
    y2: 270.2148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M364.173,174.09c-0.683,0-1.386,0.037-2.089,0.111c-0.123,0.013-0.241,0.032-0.359,0.052 l-0.146,0.023c-0.518,0.067-1.035,0.141-1.54,0.247c-0.107,0.022-0.211,0.05-0.316,0.079l-0.143,0.037 c-0.515,0.122-1.025,0.253-1.523,0.414c-0.084,0.027-0.165,0.058-0.345,0.125c-0.53,0.182-1.054,0.379-1.567,0.605l-0.214,0.103 c-0.547,0.249-1.083,0.518-1.706,0.877c-0.554,0.32-1.094,0.667-1.503,0.966l-0.124,0.081c-1.071,0.766-2.076,1.649-2.955,2.592 c-7.551,7.548-44.958,44.941-46.023,46.052v-0.001c-3.466,3.715-5.373,8.531-5.373,13.561c0,10.996,8.945,19.941,19.94,19.941 c5.568,0,10.74-2.254,14.53-6.314l45.052-45.052c4.091-3.823,6.345-8.994,6.345-14.561 C384.113,183.035,375.168,174.09,364.173,174.09z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 359.2491,
    y1: 235.4964,
    x2: 318.1692,
    y2: 276.5864,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    d: "M407.997,302.38c-10.727,7.57-23.438,12.459-37.21,13.744 c-10.182-10.182-19.625-19.625-19.625-19.625c-0.88-0.825-1.676-1.732-2.374-2.709l-0.014-0.014 c-0.335-0.475-0.642-0.949-0.935-1.453c-0.014-0.028-0.042-0.069-0.055-0.098c-0.266-0.461-0.516-0.949-0.74-1.439 c-0.028-0.069-0.055-0.14-0.098-0.209c-0.195-0.461-0.377-0.922-0.545-1.411c-0.028-0.098-0.07-0.209-0.112-0.307 c-0.14-0.447-0.266-0.922-0.363-1.382c-0.042-0.14-0.084-0.279-0.112-0.419c-0.098-0.447-0.167-0.922-0.223-1.382 c-0.028-0.154-0.055-0.307-0.069-0.461c-0.07-0.628-0.098-1.257-0.098-1.886c0-9.973,8.074-18.046,18.032-18.046 c5.21,0,9.889,2.221,13.185,5.741L407.997,302.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.3775,
    y1: 301.2848,
    x2: 358.3775,
    y2: 228.6348,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_23_)"
    },
    d: "M408.528,218.444c-0.683,0-1.386,0.037-2.089,0.111c-0.123,0.013-0.241,0.032-0.359,0.052 l-0.146,0.023c-0.518,0.067-1.035,0.141-1.54,0.247c-0.107,0.022-0.211,0.05-0.316,0.079l-0.143,0.037 c-0.515,0.122-1.025,0.253-1.523,0.414c-0.084,0.027-0.165,0.058-0.345,0.125c-0.53,0.182-1.054,0.379-1.567,0.605l-0.214,0.103 c-0.547,0.249-1.083,0.518-1.706,0.877c-0.554,0.32-1.094,0.667-1.503,0.966l-0.124,0.081c-1.071,0.766-2.076,1.649-2.955,2.592 c-7.551,7.548-44.958,44.941-46.023,46.052v-0.001c-3.466,3.715-5.373,8.531-5.373,13.561c0,10.996,8.945,19.941,19.94,19.941 c5.568,0,10.74-2.254,14.53-6.314l45.052-45.052c4.091-3.823,6.345-8.994,6.345-14.561 C428.468,227.39,419.523,218.444,408.528,218.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.2488,
    y1: 275.7961,
    x2: 361.2988,
    y2: 316.7461,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_24_)"
    },
    d: "M440.583,246.119c-1.243,13.801-6.117,26.553-13.646,37.294 c-13.143-13.116-31.218-31.204-31.218-31.204c-0.88-0.825-1.676-1.718-2.374-2.709c0,0-0.014,0-0.014-0.014 c-0.335-0.461-0.642-0.95-0.935-1.453c-0.014-0.028-0.042-0.055-0.055-0.098c-0.266-0.461-0.516-0.949-0.74-1.439 c-0.028-0.069-0.055-0.14-0.098-0.195c-0.195-0.461-0.378-0.935-0.545-1.425c-0.028-0.098-0.069-0.195-0.112-0.307 c-0.14-0.447-0.266-0.908-0.363-1.382c-0.042-0.14-0.084-0.266-0.112-0.405c-0.098-0.461-0.167-0.922-0.224-1.396 c-0.028-0.154-0.055-0.307-0.069-0.461c-0.069-0.614-0.098-1.243-0.098-1.886c0-9.973,8.074-18.046,18.032-18.046 c5.21,0,9.889,2.221,13.185,5.741L440.583,246.119z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 404.1435,
    y1: 273.8808,
    x2: 386.1435,
    y2: 291.8908,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_25_)"
    },
    d: "M427.841,233.376l-6.636-6.618c-3.29-3.533-7.962-5.747-13.171-5.747 c-9.958,0-18.035,8.077-18.035,18.048c0,0.64,0.026,1.267,0.102,1.882c0.013,0.166,0.038,0.307,0.064,0.461 c0.064,0.474,0.128,0.934,0.218,1.395c0.038,0.141,0.077,0.269,0.115,0.41c0.102,0.474,0.23,0.934,0.371,1.382 c0.038,0.102,0.077,0.205,0.115,0.307c0.166,0.486,0.346,0.96,0.538,1.421c0.038,0.064,0.064,0.128,0.102,0.192 c0.218,0.499,0.461,0.986,0.73,1.446c0.026,0.038,0.038,0.064,0.064,0.102c0.282,0.499,0.602,0.986,0.934,1.446 c0,0.013,0,0.013,0.013,0.026c0.704,0.973,1.498,1.882,2.368,2.701c0,0,6.145,6.14,13.556,13.551l12.27-12.266 c4.103-3.681,6.909-8.967,6.909-14.356C428.399,235.994,428.524,236.71,427.841,233.376z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.5286,
    y1: 232.2159,
    x2: 344.4686,
    y2: 250.2759,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_26_)"
    },
    d: "M363.523,265.344c-9.958,0-18.035,8.077-18.035,18.048c0,0.64,0.026,1.267,0.09,1.894 c0.026,0.154,0.051,0.294,0.077,0.448c0.064,0.474,0.128,0.934,0.218,1.395c0.038,0.141,0.077,0.269,0.115,0.41 c0.102,0.474,0.218,0.934,0.371,1.382c0.026,0.102,0.077,0.205,0.115,0.307c0.166,0.486,0.333,0.96,0.538,1.421 c0.038,0.064,0.064,0.128,0.102,0.192c0.218,0.499,0.461,0.986,0.73,1.446c0.026,0.038,0.038,0.064,0.064,0.102 c0.282,0.499,0.602,0.986,0.934,1.446c0,0.013,0,0.013,0.013,0.026c0.691,0.973,1.498,1.882,2.368,2.701c0,0,4.22,4.217,7.356,7.353 c2.907,0.532,2.084,0.374,4.62,0.385c5.505-0.212,10.366-2.454,14.54-6.969l12.603-12.603l-13.646-13.639 C373.405,267.559,368.733,265.344,363.523,265.344z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.7208,
    y1: 313.068,
    x2: 300.1108,
    y2: 377.688,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_27_)"
    },
    d: "M395.749,252.48c3.22,3.003,7.517,4.863,12.267,4.863c9.964,0,18.042-8.078,18.042-18.042 c0-5.204-2.217-9.881-5.742-13.173l-43.683-43.683c-3.293-3.525-7.969-5.742-13.173-5.742c-9.964,0-18.042,8.078-18.042,18.042 c0,0.639,0.035,1.269,0.1,1.891c0.016,0.156,0.05,0.305,0.07,0.459c0.061,0.468,0.127,0.934,0.223,1.39 c0.03,0.141,0.074,0.276,0.107,0.415c0.11,0.465,0.227,0.928,0.373,1.378c0.034,0.106,0.078,0.207,0.114,0.311 c0.164,0.48,0.342,0.954,0.545,1.414c0.03,0.067,0.064,0.13,0.095,0.197c0.225,0.495,0.469,0.978,0.736,1.449 c0.018,0.032,0.038,0.062,0.057,0.094c0.289,0.5,0.599,0.985,0.933,1.452c0.004,0.006,0.01,0.013,0.014,0.019 c0.701,0.98,1.497,1.883,2.374,2.703C351.161,207.918,395.341,252.116,395.749,252.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.4925,
    y1: 265.2498,
    x2: 357.4425,
    y2: 237.2997,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A6F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_28_)"
    },
    cx: 363.456,
    cy: 283.325,
    r: 18.042
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 323.1995,
    y1: 271.5468,
    x2: 258.5895,
    y2: 336.1668,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C2CECE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    style: {
      stopColor: "#AFBCBC",
      stopOpacity: 0.179
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5B6A6A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_29_)"
    },
    d: "M351.46,296.77c3.22,3.003,7.517,4.863,12.267,4.863c9.964,0,18.042-8.078,18.042-18.042 c0-5.204-2.217-9.881-5.742-13.173l-43.683-43.683c-3.293-3.525-7.969-5.742-13.173-5.742c-9.964,0-18.042,8.078-18.042,18.042 c0,0.639,0.035,1.269,0.1,1.891c0.016,0.156,0.05,0.305,0.07,0.459c0.061,0.468,0.127,0.934,0.223,1.39 c0.03,0.141,0.074,0.276,0.107,0.415c0.11,0.465,0.227,0.928,0.372,1.378c0.034,0.106,0.078,0.207,0.114,0.311 c0.164,0.48,0.342,0.954,0.545,1.414c0.03,0.067,0.064,0.13,0.095,0.197c0.225,0.495,0.469,0.978,0.736,1.449 c0.018,0.032,0.038,0.062,0.057,0.094c0.289,0.5,0.599,0.985,0.933,1.452c0.004,0.006,0.01,0.013,0.014,0.019 c0.701,0.98,1.497,1.883,2.374,2.703C306.87,252.207,351.052,296.405,351.46,296.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 362.4786,
    y1: 315.3058,
    x2: 344.4186,
    y2: 333.3658,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_30_)"
    },
    d: "M383.581,189.394l-6.954-6.945c-3.29-3.533-7.962-5.747-13.171-5.747 c-9.958,0-18.035,8.077-18.035,18.048c0,0.64,0.026,1.267,0.102,1.882c0.013,0.166,0.038,0.307,0.064,0.461 c0.064,0.474,0.128,0.934,0.218,1.395c0.038,0.141,0.077,0.269,0.115,0.41c0.102,0.474,0.23,0.934,0.371,1.382 c0.038,0.102,0.077,0.205,0.115,0.307c0.166,0.486,0.346,0.96,0.538,1.421c0.038,0.064,0.064,0.128,0.102,0.192 c0.218,0.499,0.461,0.986,0.73,1.446c0.026,0.038,0.038,0.064,0.064,0.102c0.282,0.499,0.602,0.986,0.934,1.446 c0,0.013,0,0.013,0.013,0.026c0.704,0.973,1.498,1.882,2.368,2.701c0,0,6.236,6.236,13.647,13.647l12.331-12.37 c4.644-3.955,6.845-9.778,6.98-14.244C384.197,192.176,384.011,191.998,383.581,189.394z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.8986,
    y1: 273.8358,
    x2: 302.8586,
    y2: 291.8759,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_31_)"
    },
    d: "M319.168,220.989c-9.958,0-18.035,8.077-18.035,18.048c0,0.64,0.026,1.267,0.09,1.894 c0.026,0.154,0.051,0.294,0.077,0.448c0.064,0.474,0.128,0.934,0.218,1.395c0.038,0.141,0.077,0.269,0.115,0.41 c0.102,0.474,0.218,0.934,0.371,1.382c0.026,0.102,0.077,0.205,0.115,0.307c0.166,0.486,0.333,0.96,0.538,1.421 c0.038,0.064,0.064,0.128,0.102,0.192c0.218,0.499,0.461,0.986,0.73,1.446c0.026,0.038,0.038,0.064,0.064,0.102 c0.282,0.499,0.602,0.986,0.934,1.446c0,0.013,0,0.013,0.013,0.026c0.691,0.973,1.498,1.882,2.368,2.701c0,0,4.197,4.23,7.333,7.366 c2.378,0.533,4.533,0.382,6.985,0.16c5.437-1.027,8.527-2.883,12.201-6.826l12.57-12.557l-13.616-13.616 C329.05,223.204,324.378,220.989,319.168,220.989z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.4925,
    y1: 348.2898,
    x2: 357.4425,
    y2: 320.3398,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7BD101"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    style: {
      stopColor: "#5CCD0B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08C126"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_32_)"
    },
    cx: 363.456,
    cy: 194.749,
    r: 18.042
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 287.9725,
    y1: 306.7697,
    x2: 315.9225,
    y2: 278.8198,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    style: {
      stopColor: "#FFC954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFC200"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_33_)"
    },
    cx: 319.168,
    cy: 239.037,
    r: 18.042
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 371.2625,
    y1: 306.7698,
    x2: 399.2125,
    y2: 278.8198,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D63305"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#960000"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_34_)"
    },
    cx: 408.011,
    cy: 239.037,
    r: 18.042
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.769,
    y1: 251.4348,
    x2: 213.769,
    y2: 227.4148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_35_)"
    },
    d: "M242.137,294.695v0.912c0,3.694-2.995,6.689-6.689,6.689h-8.321 c-3.694,0-6.689-2.995-6.689-6.689v-0.912c0-3.694,2.995-6.689,6.689-6.689h8.321C239.141,288.006,242.137,291,242.137,294.695z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.08,
    y1: 251.4348,
    x2: 260.08,
    y2: 227.4148,
    gradientTransform: "matrix(1.0667 0 0 -1.0667 3.2667 557.5277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5B6A6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#303033"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_36_)"
    },
    d: "M291.535,294.695v0.912c0,3.694-2.995,6.689-6.689,6.689h-8.321 c-3.694,0-6.689-2.995-6.689-6.689v-0.912c0-3.694,2.995-6.689,6.689-6.689h8.321C288.54,288.006,291.535,291,291.535,294.695z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoGameController);
export default __webpack_public_path__ + "static/media/icon-video-game-controller.1edf63a742b7bba53f6fc4e482358b53.svg";
export { ForwardRef as ReactComponent };